import React, { useState, useEffect, useRef } from 'react'
import "./tooltip.css";
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
// import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
// import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
// import CustomImage from '../../../UIComponents/CustomImage';
// import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
// import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
// import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { postAPI, postAPIForm, getURL, formatDate, convertTo12Hour, splitISODateTime } from '../../../app/api';
import { store } from '../../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import SendEmailForm from './SendEmailForm';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';
import UserInfo from '../../Users/Components/UserInfo';

export default function List({PopupID="", setIsEdit, setEditId}) {
    // Permission states
    const [canView, setCanView] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canSendEmail, setCanSendEmail] = useState(false);
    const [canViewRecordings, setCanViewRecordings] = useState(false);
    const [canSetRank, setCanSetRank] = useState(false);
    const [canViewViolations, setCanViewViolations] = useState(false);
    const [canExport, setCanExport] = useState(false);
    // Filter states
    const [filterName, setFilterName] = useState("");
    const [filterEmail, setFilterEmail] = useState("");
    const [filterPhone, setFilterPhone] = useState("");
    const [filteredParticipants, setFilteredParticipants] = useState([]);
    
    // Video Player Modal States
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [videosList, setVideosList] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videoLoading, setVideoLoading] = useState(false);
    const [videoError, setVideoError] = useState(null);

    // Rank Setting Modal States
    const [showRankModal, setShowRankModal] = useState(false);
    const [selectedParticipant, setSelectedParticipant] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedUserOpenKey, setSelectedUserOpenKey] = useState(0);
    const [allocatedRanks, setAllocatedRanks] = useState([]);
    const [rankLoading, setRankLoading] = useState(false);
    const userInfoModalTriggerRef = useRef(null);

    // Helper function to format duration from array length (seconds to human readable)
    const formatDuration = (eyeMovementArray) => {
        if (!eyeMovementArray || eyeMovementArray.length === 0) return 'N/A';
        
        const totalSeconds = eyeMovementArray.length;
        
        if (totalSeconds < 60) {
            return `${totalSeconds} second${totalSeconds !== 1 ? 's' : ''}`;
        } else if (totalSeconds < 3600) {
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            return `${minutes}min ${seconds}sec`;
        } else {
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            return `${hours}h ${minutes}m`;
        }
    };

    // Helper function to parse eye movement response and get statistics
    const getEyeMovementStats = (eyeMovementData) => {
        if (!eyeMovementData) return { total: 0, breakdown: {}, duration: 'N/A' };
        
        let data = eyeMovementData;
        if (typeof eyeMovementData === 'string') {
            try {
                data = JSON.parse(eyeMovementData);
            } catch (e) {
                return { total: 0, breakdown: {}, duration: 'N/A' };
            }
        }

        const breakdown = {};
        data.forEach(item => {
            breakdown[item] = (breakdown[item] || 0) + 1;
        });

        return {
            total: data.length,
            breakdown: breakdown,
            duration: formatDuration(data)
        };
    };

    // Tooltip action handlers for Edit and Delete
    const handleEdit = (val) => {
        // TODO: Implement edit logic
        alert('Edit action for: ' + (val?.participant_name || ''));
    };
    const handleDelete = (val) => {
        // TODO: Implement delete logic
        alert('Delete action for: ' + (val?.participant_name || ''));
    };

    const handleOpenUserInfo = (participantId) => {
        setSelectedUser(participantId);
        setSelectedUserOpenKey(prev => prev + 1);
    };

    useEffect(() => {
        if (selectedUser && userInfoModalTriggerRef.current) {
            userInfoModalTriggerRef.current.click();
        }
    }, [selectedUser, selectedUserOpenKey]);

    // Video Player Handler
    const handleViewRecording = async (val) => {
        setShowVideoModal(true);
        setVideoLoading(true);
        setVideoError(null);
        setVideosList([]);
        setSelectedVideo(null);
        
        try {
            const filter = {
                exam_id: val?.exam_id,
                user_unique_id: val?.user_unique_id,
                org_id: store_data?.org_id
            };
            
            const response = await postAPI("/exam-videos/get-video-by-user-exam", filter);
            
            if (response?.status === 1) {
                setVideosList(response?.data);
                // Auto-select first video
                setSelectedVideo(response?.data[0]);
                setVideoLoading(false);
            } else {
                setVideoError(response?.error || 'No videos found for this user');
                setVideosList([]);
                setSelectedVideo(null);
                setVideoLoading(false);
            }
        } catch (error) {
            setVideoError('Error loading videos: ' + error.message);
            setVideosList([]);
            setSelectedVideo(null);
            setVideoLoading(false);
        }
    };

    const handleCloseVideoModal = () => {
        setShowVideoModal(false);
        setVideosList([]);
        setSelectedVideo(null);
        setVideoError(null);
    };

    const handleSelectVideo = (video) => {
        setSelectedVideo(video);
    };

    // Rank Setting Handlers
    const handleOpenRankModal = (participant) => {
        setSelectedParticipant(participant);
        setShowRankModal(true);
        // Get allocated ranks from participants data
        const ranks = ParticipantsData
            .filter(p => p.user_rank && p.id !== participant.id)
            .map(p => parseInt(p.user_rank));
        setAllocatedRanks(ranks);
    };

    const handleCloseRankModal = () => {
        setShowRankModal(false);
        setSelectedParticipant(null);
        setAllocatedRanks([]);
        setRankLoading(false);
    };

    const handleSetRank = async (rank) => {
        if (!selectedParticipant) return;
        
        setRankLoading(true);
        try {
            const filter = {
                org_id: store_data?.org_id,
                exam_id: selectedParticipant.exam_id,
                user_unique_id: selectedParticipant.user_unique_id,
                rank: rank
            };
            
            const response = await postAPI("/participants/set-rank", filter);
            
            if (response?.status === 1) {
                toast.success(`Rank ${rank} assigned successfully!`);
                handleCloseRankModal();
                fetchParticipantsData(); // Refresh the list
            } else {
                toast.error(response?.error || 'Failed to set rank');
                setRankLoading(false);
            }
        } catch (error) {
            toast.error('Error setting rank: ' + error.message);
            setRankLoading(false);
        }
    };

    const {exam_id} = useParams();
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [ParticipantsData, setParticipantsData] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchParticipantsData = async () => {
        const filter = { id: store_data?.org_id, exam_id: exam_id }
        const response = await postAPI("/participants/rank-list-recommanded", filter);
        if (response?.status) {
            setParticipantsData(response?.data)
            setLoading(false)
        } else {
            setParticipantsData([])
            setLoading(false)
        }
    }

    const handleChangeStatus = async (id, status) => {
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/participants/toggle-status", filter);
        if (response?.status == 1) {
            toast.success('Status changed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/participants/remove", filter);
        if (response?.status == 1) {
            toast.success('Additional charges removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const generateInvoice = async (user_unique_id, exam_id_) => {
        const filter = { org_id: store_data?.org_id, user_unique_id: user_unique_id, exam_id: exam_id_ }
        const response = await postAPI("/pdf/create-payslip", filter);
        // const response = await postAPI("/pdf/create-payslip", filter);
        if (response?.status == 1) {
            // toast.success('Additional charges removed successfully.');
            // window.location.reload()
        } else {
            // toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanEdit(true);
                setCanSendEmail(true);
                setCanViewRecordings(true);
                setCanSetRank(true);
                setCanViewViolations(true);
                fetchParticipantsData();
            } else {
                const viewAllowed = await hasPermission("EXAM", "Participants", "VIEW");
                const editAllowed = await hasPermission("EXAM", "Participants", "EDIT");
                const emailAllowed = await hasPermission("EXAM", "Participants", "SEND_EMAIL");
                const recordingsAllowed = await hasPermission("EXAM", "Participants", "VIEW_RECORDINGS");
                const rankAllowed = await hasPermission("EXAM", "Participants", "SET_RANK");
                const violationsAllowed = await hasPermission("EXAM", "Participants", "VIEW_VIOLATIONS");
                
                setCanView(viewAllowed);
                setCanEdit(editAllowed);
                setCanSendEmail(emailAllowed);
                setCanViewRecordings(recordingsAllowed);
                setCanSetRank(rankAllowed);
                setCanViewViolations(violationsAllowed);
                
                if (viewAllowed) {
                    fetchParticipantsData();
                }
            }
        };
        checkPermissions();
    }, [])
    // Filtering logic
    useEffect(() => {
        let data = ParticipantsData;
        if (filterName) {
            data = data.filter(p => (p.participant_name || "").toLowerCase().includes(filterName.toLowerCase()));
        }
        if (filterEmail) {
            data = data.filter(p => (p.participant_email || "").toLowerCase().includes(filterEmail.toLowerCase()));
        }
        if (filterPhone) {
            data = data.filter(p => (p.participant_phone || "").toLowerCase().includes(filterPhone.toLowerCase()));
        }
        setFilteredParticipants(data);
    }, [ParticipantsData, filterName, filterEmail, filterPhone]);
    return (
        <>
            {/* Filter UI */}
            <div className="row mb-2">
                <div className="col-md-3">
                    <input type="text" className="form-control" placeholder="Filter by name" value={filterName} onChange={e => setFilterName(e.target.value)} />
                </div>
                <div className="col-md-3">
                    <input type="text" className="form-control" placeholder="Filter by email" value={filterEmail} onChange={e => setFilterEmail(e.target.value)} />
                </div>
                <div className="col-md-3">
                    <input type="text" className="form-control" placeholder="Filter by phone" value={filterPhone} onChange={e => setFilterPhone(e.target.value)} />
                </div>
            </div>
            {/* Export Button */}
            <div className="container-fluid mb-3 gap-2 p-0 d-flex justify-content-end">
                <button className="btn btn-primary btn-sm" disabled={!canExport}>
                    <Excel
                        data={{ Name: "Participants", Data: filteredParticipants }}
                        filename="participants-export.xlsx"
                    >
                        <DownloadOutlined /> Export
                    </Excel>
                </button>
            </div>
            <table className="table card-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Exam Details</th>
                        <th>Discount & Charges</th>
                        <th>Paid Amt</th>
                        <th>Recommended Rank</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody className="table-border-bottom-0">
                    <tr>
                        <td colSpan={6} className='text-center'> Total { filteredParticipants.length } Participants Found. </td>
                    </tr>
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="6" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : filteredParticipants && filteredParticipants.length > 0 ?
                            filteredParticipants.map((val, index) => (
                                <tr key={index}>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-link p-0 align-baseline text-decoration-none border-0 bg-transparent"
                                            onClick={() => handleOpenUserInfo(val?.participant_id)}
                                        >
                                            {val?.participant_name}
                                        </button>
                                        <br />
                                        <a href={`tel:${val?.participant_phone}`}>{val?.participant_phone}</a>
                                        <br />
                                        <a href={`mailto:${val?.participant_email}`}>{val?.participant_email}</a>
                                        <br />
                                    </td>
                                    <td>
                                        <p>Enroll Date: <br />
                                        {formatDate((splitISODateTime(val?.enrollment_date)[0]))?.month} {formatDate((splitISODateTime(val?.enrollment_date)[0]))?.day}, {formatDate((splitISODateTime(val?.enrollment_date)[0]))?.year} {convertTo12Hour((splitISODateTime(val?.enrollment_date)[1]))}
                                        </p>
                                        <p>Exam: {val?.exam_title}</p>
                                        <p>Fee: ₹{parseFloat(val?.enrollment_fee).toFixed(2)}</p>
                                    </td>
                                    <td>
                                        <p>
                                            Discount: ₹{parseFloat(val?.discount_amount).toFixed(2)}
                                            <br />
                                            <small>( Coupon Applied: {val?.coupon_code || 'N/A'} )</small>
                                        </p>
                                        <p>
                                            Tax: ₹{parseFloat(val?.tax_amount).toFixed(2)}
                                        </p>
                                        <p>
                                            Total Additional Charge: <br />
                                            ₹{parseFloat(val?.additional_charge_amount).toFixed(2)}
                                        </p>
                                    </td>
                                    <td>₹{parseFloat(val?.final_payable_amount).toFixed(2)}</td>
                                    <td>{val?.user_rank}</td>
                                    <td>
                                        {/* <span className="tooltip" onClick={() => generateInvoice(val?.user_unique_id, val?.exam_id)}>
                                            <span className="badge bg-label-danger me-1 cursor-pointer">
                                                <i className="fa fa-file-pdf"></i>
                                            </span>
                                            <span className="tooltiptext">Check Invoice</span>
                                        </span> */}
                                        {canViewRecordings && (
                                            <span className="tooltip" onClick={() => handleViewRecording(val)}>
                                                <span className="badge bg-label-danger me-1 cursor-pointer">
                                                    <i className="fa fa-video"></i>
                                                </span>
                                                <span className="tooltiptext">View Recording</span>
                                            </span>
                                        )}
                                        {canSetRank && (
                                            <span className="tooltip" onClick={() => handleOpenRankModal(val)}>
                                                <span className="badge bg-label-success me-1 cursor-pointer">
                                                    <i className="fa fa-check"></i>
                                                </span>
                                                <span className="tooltiptext">Set Rank</span>
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))
                            : ''
                    }
                </tbody>
            </table>
            <button
                ref={userInfoModalTriggerRef}
                type="button"
                className="d-none"
                data-bs-toggle="modal"
                data-bs-target="#UserInfoPerticipation"
                tabIndex={-1}
                aria-hidden="true"
            />
            
            {/* Rank Setting Modal */}
            {showRankModal && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fa fa-trophy me-2"></i>
                                    Set Rank for {selectedParticipant?.participant_name}
                                </h5>
                                <button type="button" className="btn-close" onClick={handleCloseRankModal} disabled={rankLoading}></button>
                            </div>
                            <div className="modal-body">
                                {selectedParticipant && (
                                    <div className="mb-4">
                                        <div className="alert alert-info" role="alert">
                                            <strong>Participant:</strong> {selectedParticipant.participant_name}<br />
                                            <strong>Exam:</strong> {selectedParticipant.exam_title}<br />
                                            <strong>Current Rank:</strong> {selectedParticipant.user_rank || 'Not Set'}
                                        </div>
                                        
                                        <h6 className="mb-3">Select Rank (1 - {ParticipantsData.length})</h6>
                                        
                                        {rankLoading ? (
                                            <div className="text-center py-5">
                                                <Loader />
                                                <p className="mt-3">Setting rank...</p>
                                            </div>
                                        ) : (
                                            <div style={{ 
                                                display: 'grid', 
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(60px, 1fr))',
                                                gap: '12px',
                                                maxHeight: '400px',
                                                overflowY: 'auto',
                                                padding: '8px'
                                            }}>
                                                {Array.from({ length: ParticipantsData.length }, (_, i) => i + 1).map(rank => {
                                                    const isAllocated = allocatedRanks.includes(rank);
                                                    const isCurrent = selectedParticipant.user_rank == rank;
                                                    
                                                    return (
                                                        <button
                                                            key={rank}
                                                            type="button"
                                                            className={`btn ${
                                                                isCurrent 
                                                                    ? 'btn-success' 
                                                                    : isAllocated 
                                                                        ? 'btn-secondary' 
                                                                        : 'btn-outline-primary'
                                                            }`}
                                                            onClick={() => handleSetRank(rank)}
                                                            disabled={isAllocated && !isCurrent}
                                                            style={{
                                                                width: '60px',
                                                                height: '60px',
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                position: 'relative'
                                                            }}
                                                            title={isCurrent ? 'Current Rank' : isAllocated ? 'Already Allocated' : `Set Rank ${rank}`}
                                                        >
                                                            {rank}
                                                            {isCurrent && (
                                                                <span style={{
                                                                    position: 'absolute',
                                                                    top: '2px',
                                                                    right: '4px',
                                                                    fontSize: '10px'
                                                                }}>
                                                                    ✓
                                                                </span>
                                                            )}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        )}
                                        
                                        <div className="mt-3">
                                            <small className="text-muted">
                                                <span className="badge bg-success me-2">✓</span> Current Rank
                                                <span className="badge bg-secondary ms-3 me-2"></span> Already Allocated
                                                <span className="badge bg-outline-primary ms-3 me-2"></span> Available
                                            </small>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary" 
                                    onClick={handleCloseRankModal}
                                    disabled={rankLoading}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Video Player Modal */}
            {showVideoModal && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
                    <div className="modal-dialog modal-xl" style={{ maxWidth: '1200px' }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Exam Recordings ({videosList.length})</h5>
                                <button type="button" className="btn-close" onClick={handleCloseVideoModal}></button>
                            </div>
                            <div className="modal-body">
                                {videoLoading ? (
                                    <div className="text-center py-5">
                                        <Loader />
                                        <p className="mt-3">Loading videos...</p>
                                    </div>
                                ) : videoError ? (
                                    <div className="alert alert-danger" role="alert">
                                        <i className="fa fa-exclamation-circle me-2"></i>
                                        {videoError}
                                    </div>
                                ) : videosList && videosList.length > 0 ? (
                                    <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: '20px' }}>
                                        {/* Video List Sidebar */}
                                        <div className="card card-body" style={{ 
                                            maxHeight: '600px',
                                            overflowY: 'auto',
                                            padding: '0.75rem'
                                        }}>
                                            <h6 className="mb-2" style={{ fontWeight: 600 }}>
                                                <i className="fa fa-list me-2"></i>
                                                Select Video
                                            </h6>
                                            {videosList.map((video, idx) => (
                                                <div
                                                    key={idx}
                                                    onClick={() => handleSelectVideo(video)}
                                                    className={`card cursor-pointer mb-2 ${selectedVideo?.id === video.id ? 'bg-label-primary border-primary' : ''}`}
                                                    style={{
                                                        padding: '0.75rem',
                                                        transition: 'all 0.3s ease',
                                                        borderWidth: selectedVideo?.id === video.id ? '2px' : '1px'
                                                    }}
                                                >
                                                    <p className="mb-1 fw-bold" style={{ fontSize: '12px' }}>
                                                        Video {idx + 1}
                                                    </p>
                                                    <small className="text-muted d-block">
                                                        {video.recordtime ? new Date(video.recordtime).toLocaleString() : 'N/A'}
                                                    </small>
                                                    <small className="mt-1 d-inline-block">
                                                        <span className={`badge ${video.is_face_verified ? 'bg-success' : 'bg-danger'}`}>
                                                            {video.is_face_verified ? 'Face OK' : 'No Face'}
                                                        </span>
                                                    </small>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Video Player Section */}
                                        {selectedVideo && (
                                            <div className="video-player-container">
                                                <video 
                                                    width="100%" 
                                                    height="400" 
                                                    controls 
                                                    controlsList="nodownload"
                                                    style={{ borderRadius: '8px', backgroundColor: '#000', marginBottom: '16px' }}
                                                >
                                                    <source src={selectedVideo?.video_url} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>

                                                {/* Video Statistics */}
                                                <div className="card card-body">
                                                    <h6 className="mb-3 fw-bold">
                                                        <i className="fa fa-info-circle me-2"></i>
                                                        Video Statistics
                                                    </h6>
                                                    
                                                    {/* Basic Info */}
                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                                                        <div className="card card-body p-2">
                                                            <strong className="text-muted d-block" style={{ fontSize: '12px' }}>Recording Time</strong>
                                                            <p className="mb-0 fw-bold">
                                                                {selectedVideo?.recordtime ? new Date(selectedVideo?.recordtime).toLocaleString() : 'N/A'}
                                                            </p>
                                                        </div>
                                                        <div className="card card-body p-2">
                                                            <strong className="text-muted d-block" style={{ fontSize: '12px' }}>Face Verified</strong>
                                                            <p className="mb-0">
                                                                <span className={`badge ${selectedVideo?.is_face_verified ? 'bg-success' : 'bg-danger'}`}>
                                                                    {selectedVideo?.is_face_verified ? 'Yes ✓' : 'No ✗'}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Eye Movement Statistics */}
                                                    {selectedVideo?.eye_movement_response && (
                                                        <div className="card card-body p-2">
                                                            <strong className="text-muted d-block" style={{ fontSize: '12px' }}>
                                                                <i className="fa fa-eye me-2"></i>
                                                                Eye Movement Analysis
                                                            </strong>
                                                            {(() => {
                                                                const stats = getEyeMovementStats(selectedVideo.eye_movement_response);
                                                                return (
                                                                    <div style={{ marginTop: '8px' }}>
                                                                        <p className="mb-2" style={{ fontSize: '12px' }}>
                                                                            <strong>Total Duration:</strong> {stats.duration}
                                                                        </p>
                                                                        {Object.keys(stats.breakdown).length > 0 && (
                                                                            <div style={{ marginTop: '8px' }}>
                                                                                <strong style={{ fontSize: '12px' }} className="d-block mb-2">Breakdown:</strong>
                                                                                {Object.entries(stats.breakdown).map(([movement, count], idx) => (
                                                                                    <div key={idx} className="card card-body p-2 mb-2" style={{ 
                                                                                        display: 'flex',
                                                                                        justifyContent: 'space-between',
                                                                                        fontSize: '12px'
                                                                                    }}>
                                                                                        <span>{movement}</span>
                                                                                        <span className="badge bg-label-primary"> 
                                                                                            {count}s ({((count / stats.total) * 100).toFixed(1)}%)
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="alert alert-info" role="alert">
                                        <i className="fa fa-info-circle me-2"></i>
                                        No videos available
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseVideoModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <UserInfo PopupID="UserInfoPerticipation" userId={selectedUser} openKey={selectedUserOpenKey} />
        </>
    )
}
